import { supabase } from '../supabase';

export interface ShipmentPriceBox {
  id: number;
  variety: string | null;
  labeled_variety: string | null;
  caliber: string | null;
  box_type: string | null;
  box_format: string | null;
  box_weight: number | null;
  color: string | null;
  category: string | null;
  box_label: string | null;
  pallet: string | null;
  quantity: number | null;
  reported_price: number | null;
  reported_price_currency: string | null;
  reported_sale_date: string | null;
}

/** Read every active boxing of the selected shipment, including large packings. */
export async function getShipmentPriceBoxes(
  shipmentId: number,
  exporterId: number,
  season?: string,
  speciesId?: number
): Promise<ShipmentPriceBox[]> {
  const rows: ShipmentPriceBox[] = [];
  let afterId = 0;
  for (;;) {
    let query = supabase
      .from('shipment_boxes')
      .select(
        'id, variety, labeled_variety, caliber, box_type, box_format, box_weight, color, category, box_label, pallet, quantity, reported_price, reported_price_currency, reported_sale_date'
      )
      .eq('shipment_id', shipmentId)
      .eq('exporter_id', exporterId)
      .is('source_deleted_at', null)
      .gt('id', afterId)
      .order('id', { ascending: true })
      .limit(1000);
    if (season) query = query.eq('season', season);
    if (speciesId) query = query.eq('species_id', speciesId);
    const { data, error } = await query;
    if (error) throw error;
    const page = (data || []) as ShipmentPriceBox[];
    rows.push(...page);
    if (page.length < 1000) return rows;
    const next = Number(page[page.length - 1].id);
    if (!Number.isFinite(next) || next <= afterId)
      throw new Error('Invalid shipment price boxing page');
    afterId = next;
  }
}
